import axios from "axios";

const isProd = process.env.NODE_ENV === "production";
const defaultApiUrl = process.env.REACT_APP_API_URL || (isProd ? "https://api.assaicartola2.shop/api/" : "http://localhost:5137/api/");

const api = axios.create({
  baseURL: defaultApiUrl,
});

export default api;